// src/services/StockSalesService.js
import api from "./api";

const StockSalesService = {
  save: (data) => api.post("/stockSales/save", data),

  getAll: (companyId, employeeId, roleId, page, limit, search, status) =>
    api.get(`/stockSales/getAll/${companyId}/${employeeId}/${roleId}`, {
      params: {
        page,
        limit,
        search,
        status
      }
    }),

  getById: (id) => api.get(`/stockSales/getById/${id}`),

  update: (id, data) => api.put(`/stockSales/update/${id}`, data),

  delete: (id) => api.delete(`/stockSales/delete/${id}`),

  previewInvoiceNo: (projectId, storeId) =>
    api.get(`/stockSales/generate-invoice/${projectId}/${storeId}`),

  approve: (id, data) =>
    api.put(`/stockSales/approve/${id}`, data),

  reject: (id, data) =>
    api.put(`/stockSales/reject/${id}`, data),

  cancel: (id, data) =>
    api.put(`/stockSales/cancel/${id}`, data),
};

export default StockSalesService;
